/**
 * Status classes for technology lifecycle states
 * Single source of truth for status classifications
 */
export const STATUS_CLASSES = {
  good: 'status-good',
  caution: 'status-caution',
  danger: 'status-danger',
  gray: 'status-gray',
} as const;

/**
 * Status class type
 */
export type StatusClass = (typeof STATUS_CLASSES)[keyof typeof STATUS_CLASSES];

/**
 * Simple status type for string-based statuses
 */
export type SimpleStatus = 'good' | 'caution' | 'danger' | 'gray';
